export const PENDING_EMAIL_CHANGE_KEY = "pendingEmailChange";
export const PENDING_EMAIL_CHANGE_TTL_MS = 30 * 60 * 1000;
export const EMAIL_CHANGE_LINK_INTENT = "emailChange";
export const EMAIL_LINK_REQUEST_OWNER_KEY = "emailLinkRequestOwner";
export const EMAIL_CHANGE_MODES = Object.freeze({
  LINK: "link",
  VERIFY_AND_CHANGE: "verifyAndChange",
});

export const normalizeEmail = (email) =>
  typeof email === "string" ? email.trim().toLowerCase() : "";

export const beginEmailLinkRequest = () => {
  const requestId = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  localStorage.setItem(EMAIL_LINK_REQUEST_OWNER_KEY, requestId);
  return requestId;
};

export const ownsEmailLinkRequest = (requestId) =>
  Boolean(requestId) && localStorage.getItem(EMAIL_LINK_REQUEST_OWNER_KEY) === requestId;

export const releaseEmailLinkRequest = (requestId) => {
  if (!ownsEmailLinkRequest(requestId)) return false;
  localStorage.removeItem(EMAIL_LINK_REQUEST_OWNER_KEY);
  return true;
};

export const getEmailChangeLinkIntent = (search = window.location.search) => {
  const continueUrl = new URLSearchParams(search).get("continueUrl");
  if (!continueUrl) return null;

  try {
    const intent = new URL(continueUrl, window.location.origin).searchParams.get("intent");
    return intent === EMAIL_CHANGE_LINK_INTENT ? intent : null;
  } catch (_) {
    return null;
  }
};

export const clearPendingEmailChange = () => {
  localStorage.removeItem(PENDING_EMAIL_CHANGE_KEY);
};

export const savePendingEmailChange = ({ email, firebaseUid, mode }, now = Date.now()) => {
  const normalizedEmail = normalizeEmail(email);
  if (
    !normalizedEmail ||
    !firebaseUid ||
    !Object.values(EMAIL_CHANGE_MODES).includes(mode)
  ) {
    throw new Error("invalid_pending_email_change");
  }

  const pending = { email: normalizedEmail, firebaseUid, mode, createdAt: now };
  localStorage.setItem(PENDING_EMAIL_CHANGE_KEY, JSON.stringify(pending));
  return pending;
};

export const getPendingEmailChange = ({ firebaseUid, mode } = {}, now = Date.now()) => {
  const raw = localStorage.getItem(PENDING_EMAIL_CHANGE_KEY);
  if (!raw) return null;

  try {
    const pending = JSON.parse(raw);
    const normalizedEmail = normalizeEmail(pending?.email);
    const isValid =
      normalizedEmail &&
      pending?.email === normalizedEmail &&
      typeof pending?.firebaseUid === "string" &&
      Object.values(EMAIL_CHANGE_MODES).includes(pending?.mode) &&
      Number.isFinite(pending?.createdAt) &&
      pending.createdAt <= now &&
      now - pending.createdAt <= PENDING_EMAIL_CHANGE_TTL_MS;

    if (!isValid) {
      clearPendingEmailChange();
      return null;
    }
    if (firebaseUid && pending.firebaseUid !== firebaseUid) {
      return null;
    }
    if (mode && pending.mode !== mode) {
      return null;
    }
    return pending;
  } catch (_) {
    clearPendingEmailChange();
    return null;
  }
};
